<template>
<!--Componente del prospecto-->
<form  class="cardForm" v-on:submit.prevent="submitForm">
    <div class="container h-100" v-show="isLoading">
            <div class="row align-items-center h-100" >
                <div class="col-8 mx-auto" style="background-color:#0d6fb8;border-radius:.375rem">
                    <div class="jumbotron" style="margin:20px">
                        <br>
                        <center>
                            <h2 style="color: white;">¡Espere mientras se envia la informacion!</h2>
                        </center>
                        <br>
                    </div>
                </div>
            </div>
        </div>
      <div class="container h-100" v-show="showdiv">
            <div class="row align-items-center h-100" >
                <div class="col-8 mx-auto" style="background-color:#0d6fb8;border-radius:.375rem">
                    <div class="jumbotron" style="margin:20px">
                        <br>
                        <br>
                        <h2 style="color: white;">Gracias por confirmar tus datos, estamos creando tu cuenta por favor valida en unos minutos tu correo, recibirás el enlace para poder acceder al portal.</h2>
                        <br>
                        <br>
                    </div>
                </div>
            </div>
    </div>
<div v-show="showform">
    <center><h2>Datos del Interesado</h2></center>

    <general @datageneralalumno="getDatageneralalumno">

    </general>

   

    <interes :tpsch="tpsch" :cicloin="ciclo"  @datainteres="getDatainteres">

    </interes>

     <div hidden="true">
                   <label class="active">Id Escuela <span>*</span></label>
                  <input  type="text" name="idSchool" class="form-control" :value="idsch">
     </div>
     

    <div class="inputControl">
         <p style="font-size:14px">Al hacer clic en <b style="color:#f68b1f" data-gtm-tr="Registro" data-gtm-accion="{step}" data-gtm-etiqueta="{resultado}">"Enviar Datos"</b>, reconoces haber leído las <a href="https://www.unitec.mx/politicas-de-privacidad/" target="_blank">Políticas de Privacidad</a> y confirmas estar de acuerdo con el uso de ellas, así como los <a href="https://www.unitec.mx/terminos-y-condiciones/" target="_blank">Términos y Condiciones</a> del sitio</p>
         </div> 

     <div hidden="true">
        <label class="active">Tipo de Escuela <span>*</span></label>
        <input  type="text" name="typeSchool"  class="form-control" :value="tpsch"> 
     </div>
    <button type="sumbit" class="cmp-button" :disabled="btn" :class="{ spanap : showbtnsend }">Enviar Datos</button>         
</div>   
    </form>
</template>
<!--Componente del prospecto-->
<style scoped>
.cardForm {

  border-radius: 6px;
  box-shadow: 0 11px 24px 0 #b0d3eb;
  border: solid 1px #5eabe0;
  background-color: white;
  border-top: solid 8px #0d6eba;
  padding: 24px;
  width: 40%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 45px;
  
  
  }
  @media only screen and (max-width: 880px) {
      .cardForm {
        width: 80%;
      }
  }

.inputControl {
  position: relative;
   margin-top: 30px;
    display: flex;
}
label {
    color: #0d6eba;
    background: white;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: -9px;
    left: 9px;
    padding: 0 8px;
  }

  input {
    border-radius: 6px;
    border: solid 1px #5eabe0;
    background-color: white;
    padding: 10px 16px;
    padding-right: 35px;
    width: 100%;
    font-size: 16px;
    color:  #505050;
  }

   button {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }

   h2 {
      margin-top: 5px;
      margin-bottom: 25px;
      color:#0d6eba;
      font-weight:700;
      font-size:24px;
    }
    .cmp-button{
        appearance:none;
        border-radius: 3px;
        cursor:pointer;
        font-size:18px;
        padding:9pt 14px 14px;
        text-align:center;
        font-weight:500;
        background-color:#f68b1f;
        border: 1px solid #f68b1f;
        color:#003053!important;
        transition:background-color .4s ease-out,color .3s ease-out,border .4s ease-out;
    }
    .spanap {
    display: none;
    }
</style>
<script>
//Componente datosgeneral.vue
import General from '../alumno/DatosgeneralesAlumno.vue'
//import Complementario from '../alumno/DatosComplementarios.vue'
import Interes from '../alumno/DatosgeneralesInteres.vue'
import axios from 'axios';
export default {
  name: 'AlumnoformComponent',
  props:['idsch','tpsch','cicloi'],
  components: {
   General,
   //Complementario,
   Interes
  },
  data(){
        return {
            isLoading: false,
            carrera:'',
            showdiv: false,
            showform: true,
            btn: false,
            showbtnsend: false,
            nivel: this.tpsch,
            ciclo: this.cicloi,
                form: {
                Typeregister: '2',
                ActividadAgenda: 'Test',
                ApellidoMaterno: '',
                ApellidoMaternoTutor: null,
                ApellidoPaterno: '',
                ApellidoPaternoTutor: null,
                AreaInteres: 'PRIMER INGRESO',
                Attemp: '',
                Organizacion:'',
                Banner: '',
                BanderaRegistro: '0',
                Calidad: '',
                Campus: '',
                Carrera: '',
                CarreraCliente: '',
                Ciclo: '',
                CorreoElectronico: '',
                CorreoElectronicoTutor: null,
                Cookie:'',
                //Edad: '21',
                Ejecutivo: '',
                EscuelaEmpresa: '',
                ExtensionOficina: null,
                Flag_Microregistro:'0',
                FuenteNegocio:'',
                FuenteObtencion:'PROMOCION',
                Genero: null,
                GUIDActividAgenda: process.env.VUE_APP_GUID_AS,
                GUIDAreaInteres: 'b0839dc4-6572-e211-b35f-6cae8b2a4ddc',
                GUIDCalidad:'',
                GUIDCampus: '',
                GUIDCarrera: '',
                GUIDCiclo: '',
                GUIDEjecutivo: '',
                GUIDEscuelaEmpresa: '',
                GUIDFuentedeObtencion:'',
                GUIDModalidad: '',
                GUIDNivel: '',
                GUIDOtroCampus:null,
                GUIDParentescoTutor:null,
                GUIDsubactividad:process.env.VUE_APP_GUID_STA,
                GUIDSubsubactividad:process.env.VUE_APP_GUID_SSTA,
                GUIDUsuario: null,
                IdCarrera: '',
                IdSchool: '',
                LandingPage:'PROMOTOR CAPTURISTA',
                Marcable: null,
                Modalidad: '',
                Nivel:'',
                Nombre: '',
                NombreTutor: null,
                NumeroCelularTutor: null,
                OtroCampus: null,
                ParentescoTutor:null,
                RegistroKAM: "1",
                SubNivel: '2',
                SubSubTipoActividad:'APLICACIÓN TEST',
                SubTipoActividad:'PROMOCION ESCUELAS',
                Telefono: '',
                TelefonoCasa: '0',
                TelefonoCasaPredictivo: null,
                TelefonoCasaTutorPredictivo:null,
                TelefonoCelularTutorPredictivo:null,
                TelefonoOficina: '',
                TelefonoOficinaPredictivo:null,
                TelefonoPredictivo: null,
                TelefonoTutor:null,
                Turno: null,
                Usuario: null,
                CorreoElectronicoCorrecto: "true",
                CorreoElectronicoTutorCorrecto:null,
                TelCelularMarcableCOFETEL: null,
                TelDomicilioMarcableCOFETEL: null,
                TelTrabajoMarcableCOFETEL: null,
                TelCelularMarcableREPEP: null,
                TelDomicilioMarcableREPEP: null,
                TelTrabajoMarcableREPEP: null,
                NumCelularTutorMarcableCOFETEL: null,
                NumCelularTutorMarcableREPEP: null,
                TelCasaTutorPredMarcableCOFETEL: null,
                TelCasaTutorPredMarcableREPEP: null,
                TelTutorMarcableCOFETEL: null,
                TelTutorMarcableREPEP: null,
            },
            idextra:'',
            newciclo:null,
            valuextra:'test',
            url:process.env.VUE_APP_URL,
            urlgeneral:process.env.VUE_APP_URL_GENERAL,
            urlpost:process.env.VUE_APP_URL_POST,
            urlpostcrm:process.env.VUE_APP_URL_POST_CRM,
            urlposthub:process.env.VUE_APP_URL_POST_HUB
        };
    },
    mounted() {
        //this.getFuentedenegocio();
        this.getEjecutivo();
        this.forceUpper();
        //this.getTeampriority();
        //this.getExtraguidinteres();
         //Data dummy
        axios.get( this.urlgeneral+'/api/dummy?auth=cdbf21d1e5cfee9eea8978751102632d' )
            .then(response => {
                let dataDummy = response.data;
                //console.log("calidadd"+dataDummy.CALIDAD.id);
                localStorage.setItem( "campus-dummy-id", dataDummy.CAMPUS.id );
                localStorage.setItem( "campus-dummy-name", dataDummy.CAMPUS.label );
                localStorage.setItem( "carrera-dummy-id", dataDummy.CARRERA.id );
                localStorage.setItem( "carrera-dummy-name", dataDummy.CARRERA.label );
                localStorage.setItem( "modalidad-dummy-id", dataDummy.MODALIDAD.id );
                localStorage.setItem( "modalidad-dummy-name", dataDummy.MODALIDAD.label );
                localStorage.setItem( "nivel-dummy-id", dataDummy.NIVEL.id );
                localStorage.setItem( "nivel-dummy-name", dataDummy.NIVEL.label );
                localStorage.setItem( "calidad-dummy-id", dataDummy.CALIDAD.id );
                localStorage.setItem( "calidad-dummy-name", dataDummy.CALIDAD.label );
            });

          axios.get( this.urlgeneral+'/api/cicloEducando' )
            .then(response => {
                let dataDummy = response.data[0];
                this.form.GUIDCiclo = dataDummy.codigo;
                this.form.Ciclo = dataDummy.name;
                localStorage.setItem( "ciclo-dummy-id", dataDummy.codigo );
                localStorage.setItem( "ciclo-dummy-name", dataDummy.name );
            });

    },
     methods: {
    forceUpper() {
    var domain = document.domain; 
    this.form.Cookie = domain;
    var url_string = window.location.href; 
    var url = new URL(url_string);
    var testId = url.searchParams.get("testId");
    if(testId == '' || testId == null){
    this.form.Banner = "PROSPECCION_EDUCANDO_W";
    }
    else{
        this.form.Banner = "PROSPECCION_EDUCANDO";
    }
    },
    getFuenteNegocio(calidad) {
    var f_n = '';
    if (calidad == 'A' || calidad == 'B' || calidad == 'C' || calidad == 'D') {
        f_n = 'ESCUELAS PROVEEDORAS';
    }
    else if (calidad == 'E') {
        f_n = 'ESCUELAS NO ESCOLARIZADAS';
    } else if (calidad == 'F') {
        f_n = 'SISTEMAS ABIERTOS';
    } else if (calidad == 'G') {
        f_n = 'ESCUELAS BACK UP';
    } else if (calidad == 'H') {
        f_n = 'EMPRESAS';
    } else if (calidad == 'A286') {
        f_n = 'ACUERDO 286';
    }
     else  {
        f_n = 'PROMOCION NO TRADICIONAL';
    }


    return f_n;
},
        getExtraguidinteres: function(){
        var nivel = this.form.Nivel;
        var agrupador  = this.form.Carrera;
        var modalidad =  this.form.Modalidad;
        var campus = this.form.Campus;
        var ciclo =   this.idextra;
        let post = {
        nivel: nivel,
        agrupador:agrupador,
        modalidad:modalidad,
        campus:campus,
        ciclo:ciclo,
        };
        const valorextratest = this;
        axios.post(this.urlgeneral+"/api/get-subnivel", post)
            .then(response => {
               let dataTeam= response.data.data[0];
               valorextratest.form.GUIDNivel = dataTeam.nivelestudios_crmit_codigounico;
               valorextratest.form.GUIDCarrera = dataTeam.carrera_codigounico;
               //console.log("identificador del nivel "+valorextratest.form.GUIDNivel) ;
            });
            //console.log("valor de prueba "+valorextratest.form.GUIDNivel);
            return true;
    },

    getUiid(){
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
    },
    getTeampriority() {
        var calidad = this.form.Calidad;
    this.form.FuenteNegocio = this.getFuenteNegocio(calidad);
    var fuente_negocio =  this.form.FuenteNegocio;
    var ciclo =  this.form.Ciclo;
    var campus =  this.form.GUIDCampus;
    var nivel =  this.form.GUIDCarrera;
    var area_de_atencion =  this.form.AreaInteres;
      const url =this.urlgeneral+"/team-priority?fuente_negocio="+fuente_negocio+'&ciclo='+ciclo
      +'&campus='+campus+'&nivel='+nivel+'&area_de_atencion='+area_de_atencion;
            axios.get( url )
            .then(response => {
                let dataTeam= response.data[0];
                this.form.Team = dataTeam.team;
                this.form.Prioridad = dataTeam.prioridad;
                this.form.Attemp = dataTeam.attemp;
                this.form.Organizacion = dataTeam.organizacion;
                this.form.GUIDLpTransaccion = this.getUiid();
            });
   
    },
      getEjecutivo() {
     var idsescuela = this.idsch;
     if(idsescuela == null || idsescuela == "null" || idsescuela == ""){
        idsescuela = 17012
     }
     console.log(idsescuela);
     this.form.IdSchool = idsescuela;
     var fechaRegistro = new Date();
     var mes =fechaRegistro.getMonth()+1;
     var fR = fechaRegistro.getFullYear()+'-'+mes+'-'+fechaRegistro.getDate()+' '+fechaRegistro.getHours()+':'+fechaRegistro.getMinutes()+':'+fechaRegistro.getSeconds();
     const url =this.urlgeneral+"/api/get-ejecutivo/"+idsescuela;
      axios.get( url )
            .then(response => {
                let dataEjecutivo= response.data[0];
                this.form.Ejecutivo = dataEjecutivo.ejecutivo_asignado_name;
                this.form.GUIDEjecutivo = dataEjecutivo.ejecutivo_asignado_id;
                this.form.GUIDUsuario = dataEjecutivo.ejecutivo_asignado_id;
                this.form.GUIDEscuelaEmpresa = dataEjecutivo.crmit_empresaescuela;
                //this.form.IdCarrera = this.idsch;
                this.form.FechaEnvioLP = fR;
                this.form.EscuelaEmpresa = dataEjecutivo.name;
                this.form.Usuario = dataEjecutivo.ejecutivo_asignado_name;
                this.form.Calidad = dataEjecutivo.crmit_calidad_id_name;
                this.form.GUIDCalidad = dataEjecutivo.crmit_calidad_id;
            });
    },
    getDatainteres: function(paramsInteres){
       // this.form.Nivel = paramsInteres.nivel;
        //this.form.GUIDNivel = paramsInteres.idnivel;
        this.form.Carrera = paramsInteres.carrera;
        this.carrera = this.form.Carrera;
        this.form.CarreraCliente = paramsInteres.carrera;
        this.form.GUIDCarrera = paramsInteres.idcarrera;
        this.form.Modalidad = paramsInteres.modalidad;
        this.form.GUIDModalidad = paramsInteres.idmodalidad;
        this.form.GUIDCampus = paramsInteres.idcampus;
        this.form.Campus = paramsInteres.campus;
        //this.form.Ciclo = paramsInteres.ciclo;
        //this.form.GUIDCiclo = paramsInteres.idciclo;
        this.idextra = paramsInteres.ciclod;
    },
     getDatageneralalumno: function(paramsAlumno) {
     console.log(paramsAlumno);
      this.form.Nombre = paramsAlumno.nombrealumno;
      this.form.ApellidoPaterno = paramsAlumno.apellidoppalumno;
      this.form.ApellidoMaterno = paramsAlumno.apellidomalumno;
      this.form.Telefono = paramsAlumno.celalumno;
      this.form.Marcable = paramsAlumno.marcable;
      this.form.CorreoElectronicoCorrecto = paramsAlumno.correocorrrecto;
      this.form.TelCelularMarcableCOFETEL = paramsAlumno.telefonomarcablecofetel;
      this.form.TelCelularMarcableREPEP = paramsAlumno.telefonomarcablerepep;
      this.form.TelDomicilioMarcableCOFETEL = paramsAlumno.telefonomarcabledcofetel;
      this.form.TelDomicilioMarcableREPEP = paramsAlumno.telefonomarcabledrepep;
      this.form.TelefonoCasa = paramsAlumno.telalumnocasa;
      this.form.CorreoElectronico = paramsAlumno.correoalumno;
      this.form.Turno = paramsAlumno.turno;
    },
    getDatacomplealumno: function(paramsAlumnocomple) {
        console.log(paramsAlumnocomple);
      //this.form.Edad = paramsAlumnocomple.edadalumno;
      this.form.Turno = paramsAlumnocomple.turnoalumno;
    },
     getPhonepredectivo(){
          var phone = this.form.Telefono;
          var newphone = '9044' + phone;
          return newphone;
     },
    getTelefonoLocalPredictivo(){
          var phone = this.form.Telefono;
          var newphone = '901' + phone;
          return newphone;
     },
     getUsuario(){
          var usuario = this.form.Nombre;
          return usuario;
     },
     submitForm(){  
    console.log(this.isLoading);
    this.showform = false;
    this.isLoading = true;
    this.btn=true;
    this.showbtnsend = true;
    var correo = this.form.CorreoElectronico;  
    var phone = this.form.Telefono;
    if(correo == ""){
    // this.disablePhone = false;
    var newMail =phone+"@unitec.mx";
    this.form.CorreoElectronico = newMail;
  
    }

    if(phone == "" && correo == ""){
    var phone2 = this.form.TelefonoCasa;
    var newMail2 = phone2+"@unitec.mx";
    this.form.CorreoElectronico = newMail2;
    }
    
    
     //var valor = this.getExtraguidinteres();
    this.form.TelefonoCasaPredictivo= this.form.TelefonoCasa;
    this.form.TelefonoPredictivo= this.form.Telefono;
        var calidad = this.form.Calidad;
        this.form.FuenteNegocio = this.getFuenteNegocio(calidad);
        var fuenteob = this.form.FuenteObtencion;
        var nivel = this.form.Nivel;
        var agrupador  = this.form.Carrera;
        var modalidad =  this.form.Modalidad;
        var campus = this.form.Campus;
        var ciclo =   this.idextra;
        let post = {
        nivel: nivel,
        agrupador:agrupador,
        modalidad:modalidad,
        campus:campus,
        ciclo:ciclo,
        };
       const aux = this;
        axios.post(this.urlgeneral+"/api/get-subnivel", post)
            .then(response => {
               let dataTeam= response.data.data[0];
               aux.form.GUIDNivel = dataTeam.nivelestudios_crmit_codigounico;
               aux.form.GUIDCarrera = dataTeam.carrera_codigounico;
               aux.form.IdCarrera = dataTeam.carreraid;
               aux.form.Nivel = dataTeam.nivelname;
              //console.log("identificador del nivel submit dentro de la consulta"+ciclos.form.GUIDNivel);
                     //console.log("identificador del nivel submit "+aux.form.GUIDNivel);
    const url =this.urlgeneral+"/api/fuenteObtencion";
    axios.get( url )
    .then(response => {
const products = response.data;
  var a= products.filter(a => a.fuente_name.includes(fuenteob));
 //console.log("ID OBTENCION"+a[0].fuente_guid); //GUID DE WEB
  this.form.GUIDFuentedeObtencion =  a[0].fuente_guid;

    var calidad = this.form.Calidad;
    this.form.FuenteNegocio = this.getFuenteNegocio(calidad);
    var fuente_negocio =  this.form.FuenteNegocio;
    var ciclo =  this.form.Ciclo;
    var campus =  this.form.GUIDCampus;
    var nivel =  this.form.GUIDCarrera;
    var area_de_atencion =  this.form.AreaInteres;
      const url =this.urlgeneral+"/team-priority?fuente_negocio="+fuente_negocio+'&ciclo='+ciclo
      +'&campus='+campus+'&nivel='+nivel+'&area_de_atencion='+area_de_atencion;
            axios.get( url )
            .then(response => {
                let dataTeam= response.data[0];
                this.form.Team = dataTeam.team;
                this.form.Prioridad = dataTeam.prioridad;
                this.form.Attemp = dataTeam.attemp;
                this.form.Organizacion = dataTeam.organizacion;
                this.form.GUIDLpTransaccion = this.getUiid();
                // aux.form.TelefonoPredictivo = aux.getPhonepredectivo();
     //aux.form.TelefonoCasaPredictivo = aux.getTelefonoLocalPredictivo();
     //this.form.Usuario = this.getUsuario();
     console.log(this.form.Turno);
     if(this.form.Turno == null || this.form.Turno == "null" || this.form.Turno == ""){
        this.form.Turno = "MATUTINO"
    }
     var information = new Object();
     information.nombre = aux.form.Nombre;
     information.apellidopaterno = aux.form.ApellidoPaterno;
     information.apellidomaterno = aux.form.ApellidoMaterno;
     information.turno = aux.form.Turno;
     information.edad = aux.form.Edad;
     information.email = aux.form.CorreoElectronico;
     localStorage.setItem("dataForm", JSON.stringify([information]));
       var url_string = window.location.href; 
    var url = new URL(url_string);
    var testId = url.searchParams.get("testId");
    var typeuser = url.searchParams.get("typeUser");
    var tyschool = url.searchParams.get("typeSchool");
    let config = {
    headers: {
    'x-api-key': "5974b29d-0314-4f0c-ba82-cb27ca31913d",
    }
    }
    let configdos = {
    headers: {
    'Content-type': "application/json",
    }
    }
         this.recordseedhub = {
         email: this.form.CorreoElectronico,   
         propiedades:[
            {
                 propiedad: "lastname",
                 valor:this.form.ApellidoPaterno
            },
            {
                 propiedad: "apellido_materno__c",
                 valor:this.form.ApellidoMaterno
            },
            {
                 propiedad: "firstname",
                 valor:this.form.Nombre
            },
            {
                 propiedad: "id_escuela_banner__c",
                 valor:this.form.IdSchool
            },
             {
                 propiedad: "nombre_escuela",
                 valor:this.form.EscuelaEmpresa
            },
             {
                 propiedad: "turno",
                 valor:this.form.Turno
            },
             {
                 propiedad: "tipo_de_escuela__c",
                 valor:tyschool
            },
            {
                 propiedad: "ea_tipo_usuario",
                 valor:typeuser
            },
            {
                 propiedad: "ea_testid",
                 valor:testId
            },
            {
                 propiedad: "ea_portal_unitec",
                 valor:"educando"
            }
         ]
     }
    var urlcrm = this.urlpostcrm
     axios.post(urlcrm, aux.form,config).then((result) => {
     console.log(result.data.scribeResponse[0].exito);
     if(result.data.scribeResponse[0].exito == 1){
        var urlhub= this.urlposthub
         axios.post(urlhub, this.recordseedhub,configdos).then((result2) => {
            console.log(this.recordseedhub);
            this.recordloghub = {
            email: this.form.CorreoElectronico,   
            recordset: this.recordseedhub
            }
            axios.post(this.urlgeneral+"/api/guardar_log_formulario_hub", this.recordloghub,configdos).then((result3) => {
                console.log(result3);
            })
            console.log(result2);
            this.showdiv = true;
            this.showform = false;
            this.isLoading = false;
        }) 
     }else{
        this.recordlogerrorcrm= {
            email: this.form.CorreoElectronico,   
            recordset: aux.form,
            response: result.data.scribeResponse[0].mensaje,
            bandera: "ERROR",
            }
            axios.post(this.urlgeneral+"/api/guardar_log_formulario", this.recordlogerrorcrm,configdos).then((result3) => {
                console.log(result3);
            })
     }
     })     
     });
     });
     });
     },
     }
}
</script>